module.exports = __webpack_public_path__ + "static/img/sznt.e206ebb2.png";